import { Route, Routes } from 'react-router-dom'
import Main from './components/client/main/Main'
import AboutUs from './components/client/about-us/AboutUs'
import Courses from './components/client/courses/Courses'
import Premium from './components/client/courses/premium/Premium'
import FreeCourses from './components/client/courses/free/FreeCourses'
import SignIn from './components/sign-in/SignIn'
import Admin from './components/admin/Admin'
import CoursesAdmin from './components/admin/AddCourse/CoursesAdmin'
import StudentsAdmin from './components/admin/AddStudent/StudentsAdmin'
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute'
import CourseDetail from './components/client/courses/premium/CourseDetail'
import FreeCourseDetails from './components/client/courses/free/FreeCourseDetails'
import AdminRoute from './components/admin/AdminRoute'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/courses" element={<Courses />} />
      <Route path="/courses/free" element={<FreeCourses />} />
      <Route path="/courses/free/:courseId" element={<FreeCourseDetails />} />
      <Route path="/auth" element={<SignIn />} />
      <Route
        path="/premium"
        element={
          <ProtectedRoute>
            <Premium />
          </ProtectedRoute>
        }
      />

      <Route
        path="/premium/nav/:courseId"
        element={
          <ProtectedRoute>
            <CourseDetail />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin"
        element={
          <AdminRoute>
            <Admin />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/courses"
        element={
          <AdminRoute>
            <CoursesAdmin />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/students"
        element={
          <AdminRoute>
            <StudentsAdmin />
          </AdminRoute>
        }
      />
    </Routes>
  )
}

export default App
